export const notifyFactory = (type, title, message, duration = 3000) => {
  // notification options factory
  return {
    customClass: `r-notification ${type}`,
    offset: 40,
    message,
    duration,
    type,
    title
  };
};
